import * as Api from '@ViewModels';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

const BASE_KEY = 'board/:boardId/reporting/activity';

export function useOpportunityReportingActivityLogQuery({
	boardId,
	fromDate,
	toDate,
	pageSize = 20,
	enabled,
}: {
	boardId: string;
	fromDate?: string;
	toDate?: string;
	pageSize?: number;
	enabled: boolean;
}) {
	const userSession = useUserSession();
	return useInfiniteQuery<Api.IPagedCollection<Api.IBoardItemActivity>>({
		enabled,
		meta: {
			toastErrorMessage: 'Failed to load activity log',
		},
		initialPageParam: undefined as string | undefined,
		getNextPageParam: lastPage => lastPage.pageToken || undefined,
		queryFn: ({ pageParam }) =>
			userSession.webServiceHelper.callAsync<Api.IPagedCollection<Api.IBoardItemActivity>>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `board/${boardId}/reporting/activity`,
					queryParams: {
						pageSize,
						...(pageParam ? { pageToken: pageParam } : {}),
						...(fromDate ? { fromDate } : {}),
						...(toDate ? { toDate } : {}),
					},
				}),
				'GET',
				undefined
			),
		queryKey: [BASE_KEY, boardId, fromDate, toDate, pageSize],
		refetchOnWindowFocus: false,
	});
}
